export const TransmittalStatus = {
  PENDING: "Pending",
  ACCEPTED: "Accepted",
  REFUSED: "Refused",
  REJECTED: "Rejected",
  REVOKED: "Revoked",
  FAD_SUBMITTED: "FAD Submitted",
  ERROR: "Error",
  RESOLVED: "Resolved"
};
